<template>
 <div>
   <headerBack :backParams="backParams" @backBtn="back()" style="position:absolute;top:0;left:0;z-index:999"></headerBack>
   <div id="mapWrap"></div>
 </div>
</template>
<script>
// import AMap from 'AMap'
// import AMapUI from 'AMapUI'
import {decodeBusSeq, decodeLatLng, decodeBusNum} from '@/utils/transform'
import headerBack from '@/components/headerBack'
export default {
  name: 'lineMap',
  components:{headerBack},
  data () {
    return {
      mapWrap:'',
      lineInfo:'',
      nowStation:'',
      carMarker:[],
      carTimer:null,
      currentPosition:{},
      centerLng:'',
      centerlat:'',
      currentPoint:{
        lng:'',
        lat:''
      },
      backParams:{
        title:'查看地图'
      },
      markerFrist:null,
      stationName:'',
      markerList:[],
      lineParams:{}
    }
  },
  beforeRouteLeave(to, from, next){
  //  console.log('离开首页，清除定时器')
    next()
    clearInterval(this.carTimer)
     this.carTimer = null
  },
 
  mounted () {
    this.lineParams =  this.$route.params.lineParams || this.$session.getSession('lineParams')
    this.currentPosition =  this.$route.params.currentPosition || this.$session.getSession('currentPosition')//当前站点
    this.initMap()
    this.$wxHide()
  },
  methods: {
    initMap () {
      this.mapWrap = new AMap.Map('mapWrap', {
            resizeEnable: true, //是否监控地图容器尺寸变化
            zoom:10, //初始化地图层级
        })
      this.handleArr()
       this.carTimer = setInterval(()=>{
           this.getBusInfo();
      },1000*5)
      //

     },
    //处理画线路的经纬度
     handleArr(){
      let mapList =[]
      //画线路
      this.lineParams.lineMapList.forEach(item => {
      
         let arr =[item.longitude,item.latitude]
           mapList.push(arr)
      })
      //画站点
      let lineStationList = []
      lineStationList =this.lineParams.lineStationList.map(item => {
            // 解析站序 和 经纬度
              // let obj = {
              //   lat: decodeLatLng(item.latitude),
              //   lng: decodeLatLng(item.longitude)
              // }
               let obj = {
                lat: item.latitude,
                lng: item.longitude
              }
              return Object.assign({}, item, obj)
             })
    
      this.drawLine(mapList)
      this.drawStation(lineStationList)
     
    },
    //绘制线路
    drawLine(pointList){
      var polyline = new AMap.Polyline({
          path: pointList,
          strokeColor:'#22B2ED',   // 线颜色
          strokeWeight:6          // 线宽
       })
       polyline.setMap(this.mapWrap)
    },
    //绘制站点 
    drawStation(stationList){
         this.markerList = []
         let iconSelf = new AMap.Icon({
                size: new AMap.Size(16, 16),
                image: require('../../assets/image/lineCircle.png'),
                imageSize: new AMap.Size(16,16),
                
          });
          let iconCenter = new AMap.Icon({
                size: new AMap.Size(24, 24),
                image: require('../../assets/image/stationSign.png'),
                imageSize: new AMap.Size(24, 24) 
          });
          for (var i = 0, marker; i < stationList.length; i++) {
              var marker = new AMap.Marker({
                   position: [stationList[i].lng,stationList[i].lat],//不同标记点的经纬度
                   map:this.mapWrap,
                   icon:stationList[i].stationId == this.currentPosition.stationId ? iconCenter :iconSelf,
                   zIndex:300,
                   id:stationList[i].stationId,
                    offset: stationList[i].stationId == this.currentPosition.stationId ? new AMap.Pixel(-12, -12) :new AMap.Pixel(-8, -8)
                });
               marker.setLabel({
                      content:`<div class='info'>${stationList[i].stationName}</div>`, //设置文本标注内容
                      direction: 'right' //设置文本标注方位
                    });
              this.markerList.push(marker)
          }
         this.mapWrap.add(this.markerList)
        //  let centerMarker = this.markerList.filter(item=>{
        //    return item.id ==this.currentPosition.stationId
        //  })[0]
        //  this.mapWrap.setFitView(centerMarker);
         this.mapWrap.setZoomAndCenter(15, [this.currentPosition.longitude,this.currentPosition.latitude])
     },
    //绘制车
     drawCar(busList){
        let iconSelf = new AMap.Icon({
                size: new AMap.Size(24, 24),
                image: require('../../assets/image/bus.png'),
                imageSize: new AMap.Size(24,24) 
          });
       
          for (var i = 0, marker; i < busList.length; i++) {
                var marker = new AMap.Marker({
                    position: [busList[i].lng ,busList[i].lat],//不同标记点的经纬度
                    map: this.mapWrap,
                    icon: iconSelf,
                    zIndex:300,
                    offset: new AMap.Pixel(-12, -12)
                 });
                 marker.setLabel({
                       content:`<div class='carInfo'>${busList[i].busNum}</div>`, //设置文本标注内容
                       direction: 'top' //设置文本标注方位
                   });
                 this.carMarker.push(marker)
              }
          this.mapWrap.add(this.carMarker)
    },
    //点击站点,自适应地图
    setFitMap(lng,lat,stationName){
       if(this.markerFrist){
          this.mapWrap.remove(this.markerFrist)
       }
        let iconSelf = new AMap.Icon({
                size: new AMap.Size(24, 24),
                image: require('../../assets/image/stationSign.png'),
                imageSize: new AMap.Size(24, 24) 
        });
      
        this.markerFrist =  new AMap.Marker({
                    position: [lng,lat],//不同标记点的经纬度
                    map: this.mapWrap,
                    icon: iconSelf,
                    //offset:new AMap.Pixel(-150, -150)
                  });
        this.markerFrist.setLabel({
                       content:`<div class='info'>${stationName}</div>`, //设置文本标注内容
                       direction: 'right' //设置文本标注方位
                  });  
         this.mapWrap.setFitView(this.markerFrist);
     },
     // 车辆位置
    getBusInfo () {  
      this.mapWrap.remove(this.carMarker)
      this.carMarker = []
      const params = {
        businessType: this.lineParams.businessType, // 业务类型 ,1普通公交,2定制公交
        dirctionType: this.lineParams.dirctionType, // 上下行  1 上行  2 下行
        lineCode:this.lineParams.lineCode, // 线路编码
        lineType:this.lineParams.lineType, // 线路类型,1主线2区间3支线4大站快车
      }
      this.$api['station.busPosition'](params).then(res => {
        if (res.length) {
          this.allBus = res.map(item => {
            // 解析站序 和 经纬度
              let obj = {
                seq: decodeBusSeq(item.seq),
                lat: decodeLatLng(item.latitude),
                lng: decodeLatLng(item.longitude),
                busNum: decodeBusNum(item.busNum)
              }
              return Object.assign({}, item, obj)
             }).sort((a, b) => a.seq - b.seq)
              this.drawCar(this.allBus)
          } else {
             this.allBus = []
          }
      })
    },
    back(){
       this.$router.push({name:'lineDetails'})
    },

  }
}
</script>
<style lang="scss" scoped>
  #mapWrap {
    width: 100%;
    height:100vh;
  }
::v-deep{
   .amap-marker-label{
      border:1px solid #22B2ED;
      border-radius:4px;
     
      .info{
        position: relative;
        top: 0;
        right: 0;
        min-width: 0;
        color:#333!important;
        font-size:12px;
        font-weight: 600;
       }
      .carInfo{
        position:relative;
        top:0px;
        right:0px;
        min-width:0;
        color:#546AD9;
        font-size:12px;
        background:#fff;
        border-radius:4px;
        padding: 0.02rem;
      }
    }
  }
</style>


